import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";

@Component({
  selector: 'app-modal-view-produit-bareme',
  templateUrl: './modal-view-produit-bareme.component.html',
  styleUrls: ['./modal-view-produit-bareme.component.scss']
})
export class ModalViewProduitBaremeComponent implements OnInit {

  busyGet: Subscription;
  itemToSave: any = {};
  itemToAdd:any = []
  filiale_id:any
  modalRef: BsModalRef;
  user: any = {};
  currentData: any;
  itemsPrestatairereseauDeSoin: any[];
  indiceTab: number=0;


  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
        this.user = this.authService.getCurrentUser()
        this.filiale_id = this.user.filiale_id

    setTimeout(() => {
      if (this.currentData) {
        this.getItems(this.currentData.id)
        
      }
    }, 50);

  }

  selectedChangeValue(event : any)
  {
    console.log("le event selectedChangeValue",event);
    
    if(!event) this.indiceTab = 0;

    this.indiceTab = event;
  }
  
  getItems(id) {
    this.itemToSave={}
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 10,
      data: {
        bareme_id:id
      },
    };
  
    this.busyGet = this.restClient
      .post("produitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);
  
          if (res && res["items"] && res["items"].length ) {
            this.itemToSave = res["items"][0]
            console.log('items: ',res["items"])
            
          } else {
            this.itemToSave = {};
          }
  
        },
        (err) => { 
          this.itemToSave = {};
        }
      );
  }
  
  ngOnInit() {

 
  }

}
